import NavbarButton from '../components/NavbarButton/NavbarButton'

import type { TNavbarButton, TNavbarButtonData } from '../definitions'

/**
 * Gombok kirajzolása.
 * @param btnProps - Gombok adatai.
 * @param type     - Gomb típusa.
 */
export default function renderButtons (btnProps: TNavbarButtonData, type: TNavbarButton = 'default'): HTMLElement[] {
  return btnProps.map((props) => {
    const { onClick, text = '' } = props

    return (
      <NavbarButton
        text={ text }
        type={ type }
        onClick={ () => onClick() }
      />
    )
  })
}
